export var PeriodCodes;
(function (PeriodCodes) {
    PeriodCodes[PeriodCodes["Pack"] = 1] = "Pack";
    PeriodCodes[PeriodCodes["Month"] = 2] = "Month";
    PeriodCodes[PeriodCodes["Season"] = 3] = "Season";
    PeriodCodes[PeriodCodes["Year"] = 4] = "Year";
})(PeriodCodes || (PeriodCodes = {}));

/**
 * 最新会员体系参数
 * 会员体系 iframe url 参数
 * memberType: 0 标准版,1,动画pro版，2,pro+版
 */
export var MemberTypes;
(function (MemberTypes) {
    MemberTypes[MemberTypes["Shop"] = -1] = "Shop";
    MemberTypes[MemberTypes["BaseEnterprise"] = 0] = "BaseEnterprise";
    MemberTypes[MemberTypes["Enterprise"] = 1] = "Enterprise";
    MemberTypes[MemberTypes["UpEnterprise"] = 2] = "UpEnterprise";
    MemberTypes[MemberTypes["EnterpriseAI"] = 3.1] = "EnterpriseAI";
    MemberTypes[MemberTypes["UpEnterpriseAI"] = 4] = "UpEnterpriseAI";
})(MemberTypes || (MemberTypes = {}));

export var PageCodes;
(function (PageCodes) {
    PageCodes[PageCodes["480P"] = 2] = "480P";
    PageCodes[PageCodes["720P"] = 3] = "720P";
    PageCodes[PageCodes["1080P"] = 4] = "1080P";
    PageCodes[PageCodes["1440P"] = 99] = "1440P";
    PageCodes[PageCodes["AIMatting"] = 6] = "AIMatting";
    PageCodes[PageCodes["AIDrawing"] = 7] = "AIDrawing";
    PageCodes[PageCodes["AIDubbing"] = 5] = "AIDubbing";
    PageCodes[PageCodes["draftNumber"] = 9] = "draftNumber";
    PageCodes[PageCodes["materialCapacity"] = 18] = "materialCapacity";
    PageCodes[PageCodes["pptImport"] = 13] = "pptImport";
    PageCodes[PageCodes["applyWatermark"] = 1] = "applyWatermark";
    PageCodes[PageCodes["removeWatermark"] = 1] = "removeWatermark";
    PageCodes[PageCodes["selfDefineCover"] = 11] = "selfDefineCover";
    PageCodes[PageCodes["selfDefineWatermark"] = 8] = "selfDefineWatermark";
    PageCodes[PageCodes["videoDuration"] = 12] = "videoDuration";
    PageCodes[PageCodes["worksNumber"] = 10] = "worksNumber";
    PageCodes[PageCodes["quickExport"] = 100] = "quickExport";
    PageCodes[PageCodes["checkResource"] = 14] = "checkResource";
    PageCodes[PageCodes["checkResourceExport"] = 15] = "checkResourceExport";
    PageCodes[PageCodes["checkResourcePreview"] = 16] = "checkResourcePreview";
    PageCodes[PageCodes["vipTemplate"] = 17] = "vipTemplate";
    PageCodes[PageCodes["entryBtn"] = 19] = "entryBtn";
    PageCodes[PageCodes["AIAnchorman"] = 20] = "AIAnchorman";
    PageCodes[PageCodes["AISpeaker"] = 21] = "AISpeaker";
    PageCodes[PageCodes["AITemplate"] = 22] = "AITemplate";
    PageCodes[PageCodes["AIBackground"] = 23] = "AIBackground";
    PageCodes[PageCodes["AIText"] = 24] = "AIText";
    PageCodes[PageCodes["AIMaterial"] = 25] = "AIMaterial";
    PageCodes[PageCodes["AIChat"] = 26] = "AIChat";
})(PageCodes || (PageCodes = {}));

export var EnterpriseLevels;
(function (EnterpriseLevels) {
    EnterpriseLevels[EnterpriseLevels["EnterpriseBasic"] = 142] = "EnterpriseBasic";
    EnterpriseLevels[EnterpriseLevels["Enterprise"] = 143] = "Enterprise";
    EnterpriseLevels[EnterpriseLevels["EnterpriseS"] = 144] = "EnterpriseS";
    EnterpriseLevels[EnterpriseLevels["EnterpriseAI"] = 145] = "EnterpriseAI";
    EnterpriseLevels[EnterpriseLevels["EnterpriseSAI"] = 141] = "EnterpriseSAI";
})(EnterpriseLevels || (EnterpriseLevels = {}));

/**
 * 动画会员体系 季度 or 年度
 * 旧参数PeriodCodes废弃
 * Season 0 季度
 * Year 1 年度
 */
export var PeriodTypes;
(function (PeriodTypes) {
  PeriodTypes[PeriodTypes["Season"] = 0] = "Season";
  PeriodTypes[PeriodTypes["Year"] = 1] = "Year";
})(PeriodTypes || (PeriodTypes = {}));


// WEBPACK FOOTER //
// ./src/plugins/memberGuide/codes.js